import { getQueryString } from "@/utils";
import { BussinessType } from "@/utils/enum";
import { useEffect, useState } from "react";
import { queryRefundDetail, createRefund } from "./service";
import { RefundDetailObject, mockData } from "./mode";
import Toast from "@df-mobile/toast";

export const useapplyRefundHooks = () => {
  const [sourceData, setSourceData] = useState<RefundDetailObject>();
  const bussinessType = Number(getQueryString("type") || 1);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    loadDetailData();
    // setSourceData(mockData);
  }, []);

  /**加载详情数据 */
  const loadDetailData = () => {
    const sn = getQueryString("sn");
    const param = {
      sn,
    };
    queryRefundDetail(param)
      .then((res) => {
        setIsLoading(false);
        if (res?.Data) {
          setSourceData(res?.Data);
        } else {
          setSourceData({});
          Toast({content: res?.Message || ''})
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleCreateRefund = (param?: any) => {
    // window.history.back();
    createRefund(param).then(res=>{
      // 申请成功
        if(res?.Data){
          Toast({content: '提交成功'});
          window.history.back();
        }else {
          Toast({content: res?.Message || '提交失败'})
        }
    })
  }

  return {
    loadDetailData,
    sourceData,
    isLoading,
    handleCreateRefund
  };
};
